// extracted by mini-css-extract-plugin
module.exports = {"TooltipMenu":"TooltipMenu_TooltipMenu__FE4xv","ScaleIn":"TooltipMenu_ScaleIn__BIpc5","Active":"TooltipMenu_Active__3yv14","Arrow":"TooltipMenu_Arrow__29_va"};